import { render, staticRenderFns } from "./MyContent.vue?vue&type=template&id=45327cab&scoped=true&"
import script from "./MyContent.vue?vue&type=script&lang=js&"
export * from "./MyContent.vue?vue&type=script&lang=js&"
import style0 from "./MyContent.vue?vue&type=style&index=0&id=45327cab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45327cab",
  null
  
)

export default component.exports